import { StoreBadgeApi } from '../../generated/api';
import configuration from './configuration';

export default new StoreBadgeApi(configuration);
